export default "__VITE_ASSET__DLgEEHIe__"